
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "FormPic",
})
export default class extends Vue {

  //以下是图片相关操作
  private islarge = false;
  private dashboardModel = {
    captureimage: "./img/1.jpg",
  };
  private showPictureSmall = true;
  private showPictureLarge = false;
  private zoomimage() {
    console.log("放大缩小图片");
    if (this.islarge == true) {
      this.showPictureLarge = false;
      this.showPictureSmall = true;
      //this.tableshow = true;
      this.islarge = false;
    } else {
      this.showPictureLarge = true;
      this.showPictureSmall = false;
      //this.tableshow = false;
      this.islarge = true;
    }
  }
  // @Watch("formmodel2", { deep: true })
  // onChildChanged(val: string) {
  //   this.$emit("get-form2-value", val);
  // }
  // private formmodel2 = {
  //   checked_getorderdestnationorg: true,
  //   checked_voice: false,
  //   checked_needweight: true,
  // };
}
